<script lang="ts">
  import PlaidModal from "@retailer/svelte/Payments/PlaidModal.svelte";

  import { paymentInstrumentsStore } from "@retailer/svelte/stores/PaymentInstrumentStore";

  import type { PaymentInstrument } from "@shared/types/PaymentInstrument";
  import type { BankAccountMetaData } from "@retailer/stores/BankAccountStore";

  import * as PaymentInstrumentService from "@retailer/services/payment_instrument_service";

  export let open: boolean = false;
  export let enteredMicrodepositFlow: boolean = false;
  export let onCloseModals: () => void;
  export let onSavePaymentInstrument: (paymentInstrument: PaymentInstrument) => void;
  export let verificationStatuses: string[] = [];

  // functions
  const afterPlaidSuccess = async (metadata: BankAccountMetaData) => {
    // Using foreach to reactively update verification statuses
    metadata?.accounts.forEach(
      account => (verificationStatuses = [...verificationStatuses, account.verification_status])
    );
    enteredMicrodepositFlow = hasPendingStatus(verificationStatuses);
    open = false;
    onCloseModals();
    await PaymentInstrumentService.get();

    if ($paymentInstrumentsStore.paymentInstruments.length == 0) return;

    let newestInstrument = $paymentInstrumentsStore.paymentInstruments[0];

    for (let instrument of $paymentInstrumentsStore.paymentInstruments) {
      if (new Date(instrument.created_at) > new Date(newestInstrument.created_at)) {
        newestInstrument = instrument;
      }
    }

    onSavePaymentInstrument(newestInstrument);
  };

  const hasPendingStatus = (statuses: string[]) => {
    return (
      statuses.includes("pending_automatic_verification") ||
      statuses.includes("pending_manual_verification")
    );
  };

  const afterPlaidExit = async () => {
    open = false;
    onCloseModals();
  };

</script>

{#if open}
  <PlaidModal afterSuccess={afterPlaidSuccess} afterExit={afterPlaidExit} />
{/if}
